module.exports = __webpack_public_path__ + "assets/images/logo-healthid.fc8b8c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-healthid.png
// module id = 629
// module chunks = 1